import { useInView as useReactInView } from 'react-intersection-observer';

export function useInView() {
  const [ref, inView, entry] = useReactInView();

  const rootIsBelowTarget = (entry?.boundingClientRect.bottom ?? 0) < 0;

  return {
    inViewRef: ref,
    inView,
    entry,
    rootIsBelowTarget,
  };
}
